(() => {
  if (customElements.get('cosmo-product-gallery')) return;
  class CosmoProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.track = this.querySelector('.cp-gallery-track');
      this.slides = Array.from(this.querySelectorAll('.cp-gallery-slide'));
      if (!this.track || !this.slides.length) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.status = this.querySelector('[data-gallery-status]');
      this.querySelector('.cp-gallery-controls').hidden = this.slides.length < 2;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target !== this.track) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {...options, passive:true});
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    move(direction) {
      const step = this.slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0);
      this.track.scrollBy({left:step * direction, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      const viewport = this.track.getBoundingClientRect();
      const visible = this.slides.map((slide, index) => ({rect:slide.getBoundingClientRect(), index})).filter(({rect}) => Math.min(rect.right, viewport.right) - Math.max(rect.left, viewport.left) > rect.width / 2);
      if (visible.length) {
        const first = visible[0].index + 1;
        const last = visible[visible.length - 1].index + 1;
        const label = (first === last ? first : first + '–' + last) + ' / ' + this.slides.length;
        if (this.status.textContent !== label) this.status.textContent = label;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
  }
  customElements.define('cosmo-product-gallery', CosmoProductGallery);
})();
